export const dangerText = "#ca1515";
